import { Container } from 'src/components/common/Container'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Typography } from 'src/components/common/Typography'
import { Roboto_num2_b16, Roboto_num4_b12 } from 'src/styles/fonts/RobotoFonts'
import { DateUtils } from 'src/utils/date'
import { useCountdown } from 'src/hooks/useCountDown.hook'
import { HotDealItemListsSpace } from 'src/types/api'

const HotDealComingSoon = ({ StartDT }: Pick<HotDealItemListsSpace.HotDealItemType, 'StartDT'>) => {
  const { getDayDifference, expiration1Days, DateFormat } = DateUtils
  const { countStart, count } = useCountdown({
    countExpiredCallbackFn: () => window.location.reload(),
  })
  const itemsOfSellFlag = {
    date: expiration1Days(StartDT) ? DateFormat(StartDT, 'YYYY-MM-DD') : StartDT,
    dateDisplayText: `${expiration1Days(StartDT) ? `D-${getDayDifference(StartDT, 'days')}` : `${count}`}`,
  }
  const { dateDisplayText, date } = itemsOfSellFlag

  useEffect(() => {
    countStart(Number(getDayDifference(date, 'seconds')))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <S.HotDealComing.Container $option="flex_column" $row_gap="8px">
      <S.HotDealComing.DateContainer>
        <S.HotDealComing.DDay $fontStyle={Roboto_num4_b12} $color="var(--brand-50)">
          {dateDisplayText}
        </S.HotDealComing.DDay>
      </S.HotDealComing.DateContainer>
      <Typography $fontStyle={Roboto_num2_b16} $color="var(--black-70)">
        오픈 예정
      </Typography>
    </S.HotDealComing.Container>
  )
}
export default HotDealComingSoon
const S = {
  HotDealComing: {
    Container: styled(Container)`
      text-align: left;
    `,
    DateContainer: styled(Container)`
      display: flex;
      align-items: center;
      border-radius: 20px;
      border: 1px solid var(--black-10);
      background: var(--white);
      width: fit-content;
    `,
    DDay: styled(Typography)`
      display: flex;
      padding: 0 8px;
      align-items: center;
      height: 22px;
    `,
  },
}
